import { Container } from "./styles";

export default function ContainerLayout(props) {
  return <Container {...props} />;
}
